import Rest from '@services/Rest';

/**
 * @typedef {SalesService}
 */
export default class SalesService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sale'

  updateClientEmail(saleId, email) {
    return this.put(`/${saleId}/client/email`, {
      email,
      confirmation: 'ALTERAR E-MAIL',
    })
  }

  // The refund modals show the failure inline, so the interceptor must not toast it too
  // (eng-docs front-end error-handling Rule 1: one channel per error).
  refund(saleId, confirmation) {
    return this.post(`/${saleId}/refund`, { confirmation }, { selfHandledError: true })
  }

  cancelSubscription(clientContractId, confirmation) {
    return this.getHttp()
      .delete(`${this.constructor.base}/sales-next/subscription/${encodeURIComponent(clientContractId)}`, {
        data: { confirmation },
      })
      .then(this.constructor.then)
  }

  getRefundReceipt(saleId) {
    return this.get(`/refund-pdf/${saleId}`).then((response) => {
      const pdf =
        (response && response.data && response.data.pdf) ||
        (response && response.messages && response.messages.pdf)

      if (!pdf) {
        throw new Error('Refund receipt PDF not found in response')
      }

      return pdf
    })
  }
}
